module.exports = __webpack_public_path__ + "static/media/expand.f2f470fd.svg";